<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Minutas Reuniones</h4>
            <div class="small text-muted">Administración de todas las minutas de reuniones</div>
          </b-col>

          <b-col sm="5">
            <b-button @click="add()" type="button" variant="primary" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Agregar Minuta">
              <i class="fa fa-plus"></i> Agregar
            </b-button>

            <b-col sm="12" class="d-none d-md-block" v-if="!table.mostrarFiltros">
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" @click="table.mostrarFiltros=true" v-b-tooltip.hover title="Mostrar filtros">
                <i class="fa fa-filter"></i> Mostrar Filtros
              </b-button>
            </b-col>
            <b-col sm="12" class="d-none d-md-block" v-else>
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" v-if="table.mostrarFiltros" @click="table.mostrarFiltros=false" v-b-tooltip.hover title="Ocultar filtros">
                <i class="fa fa-window-close"></i>
              </b-button>
            </b-col>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row v-if="table.mostrarFiltros">
          <b-col sm="3">
            <b-row>
              <b-col md="6" class="pr-0">
                <b-form-input type="date" size="md" v-model="filter.date_start" placeholder="Fecha Desde"></b-form-input>
              </b-col>
              <b-col md="6" class="pl-0">
                <b-form-input type="date" size="md" v-model="filter.date_end" placeholder="Fecha Hasta"></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="6">
            <b-row>
              <b-col sm="4">
                <b-form-input v-model="filter.title" placeholder="Título" size="md"></b-form-input>
              </b-col>
              <b-col sm="4">
                <v-select :options="arr.filter.staff" v-model="filter.staff" placeholder="Staff" :multiple="true" :select-on-tab="true"></v-select>
              </b-col>
              <b-col sm="4">
                <v-select :options="arr.filter.sellers" v-model="filter.sellers" placeholder="Vendedores" :multiple="true" :select-on-tab="true"></v-select>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="1">
            <b-button variant="outline-dark" @click="filterReport()">
              <b-icon icon="filter" class="mr-1" style="font-size:15px;"></b-icon>
              Filtrar
            </b-button>
          </b-col>
          <b-col sm="2">
            <b-link>
              <export-excel
                class = 'pull-right mt-3'
                :data = "arr.export"
                worksheet = "Minutas Reuniones"
                name = "reports-meetings.xls">
                Exportar Datos
              </export-excel>
            </b-link>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <b-table class="mb-0"
                    responsive="sm"
                    head-variant="dark"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    v-if="table.items.length">

                <template v-slot:cell(id)="data">
                  <b>{{ data.item.id }}</b>
                </template>

                <template v-slot:cell(date)="data">
                  {{ moment(data.item.date).format('DD MMMM YYYY') }}
                </template>

                <template v-slot:cell(title)="data">
                  <div v-if="data.item.title">
                    <b>{{data.item.title}}</b>
                  </div>
                </template>

                <template v-slot:cell(responsable)="data">
                  <div v-if="data.item.staff_id">
                    <b-avatar :src="data.item.staff.image"
                              v-if="data.item.staff.image">
                    </b-avatar>
                    <b-avatar v-else
                              variant="dark">
                    </b-avatar>
                    <b-icon icon="blank"></b-icon>
                    <b :title="'STAFF: ' + data.item.staff.name">
                      {{data.item.staff.name}}
                    </b>
                  </div>
                </template>

                <template v-slot:cell(seller)="data">
                  <div v-if="data.item.sellers_id">
                    <b-avatar :src="data.item.seller.staff.image"
                              v-if="data.item.seller.staff && data.item.seller.staff.image">
                    </b-avatar>
                    <b-avatar v-else
                              variant="dark">
                    </b-avatar>
                    <b-icon icon="blank"></b-icon>
                    <b :title="'VENDEDOR: ' + data.item.seller.name">
                      {{data.item.seller.name}}
                    </b>
                  </div>
                </template>

                <template v-slot:cell(zona)="data">
                  <div v-if="data.item.zone">
                    {{data.item.zone.name}}
                  </div>
                </template>

                <template v-slot:cell(observations)="data">
                  <div v-if="data.item.observations">
                    <div v-if="data.item.observations.length >50" :title="data.item.observations">
                      {{data.item.observations.substr(0, 50)}}
                    </div>
                    <div v-else>
                      {{data.item.observations}}
                    </div>
                  </div>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">

                    <b-dropdown-item @click="irDetail(data.item)">
                      <b-icon icon="card-text"></b-icon> Detalle
                    </b-dropdown-item>

                    <b-dropdown-header>Acciones</b-dropdown-header>
                    <b-dropdown-item @click="edit(data.item)" v-if="access.elements.editReport">
                      <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)" v-if="access.elements.deleteReport">
                      <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>
          </b-col>

          <b-col>
            <nav>
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="getRowCount(table.items)"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
            </nav>
          </b-col>
        </b-row>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              header-bg-variant="dark"
              header-text-variant="white"
              no-close-on-esc
              no-close-on-backdrop>
        <div slot="modal-header">
          {{this.modal.form.title}}
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Fecha">
              <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Título">
              <b-form-input
                v-model="crud.form.title"
                placeholder="Ingrese el título"
                size="sm"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <FindObject render="search"
                        type="sellers"
                        @select-object="loadSellers($event)"
                        :valueID="crud.form.sellers_id"/>
          </b-col>

          <b-col md="12">
            <b-form-group label="Zona">
              <v-select :options="arr.select.zones" v-model="crud.form.sellers_zone" placeholder="Zona (opcional)" :select-on-tab="true" @input="loadZone($event)"></v-select>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Mensaje">
              <b-form-textarea
                v-model="crud.form.observations"
                placeholder="Ingresar el mensaje..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()">Guardar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import moment from 'moment'
  import FindObject from '@/components/inc/find/findObject'
  import Vue from 'vue'
  import excel from 'vue-excel-export'
  import Storage from '@/handler/storageSession'
  Vue.use(excel)

  export default {
    components: {
      FindObject,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.INFORME_REUNIONES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudReport',
          elements: {
            editReport: true,
            deleteReport: true
          }
        },
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID', sortable: true, class: "align-middle"},
            {key: 'date', label: 'Fecha', class: "align-middle"},
            {key: 'title', label: 'Título', class: "align-middle"},
            {key: 'responsable', label: 'Responsable', class: "align-middle"},
            {key: 'seller', label: 'Vendedor', class: "align-middle"},
            {key: 'zona', label: 'Zona', class: "align-middle"},
            {key: 'observations', label: 'Mensaje', class: "align-middle"},
            {key: 'f_action', label:'', class: "align-middle"},
          ],
          mostrarFiltros: true,
          currentPage: 1,
          perPage: 50,
        },
        crud: {
          form: {
            id: 0,
            date: '',
            title: '',
            observations: '',
            staff_id: 0,
            sellers_id: 0,
            sellers: null,
            sellers_zone_id: 0,
            sellers_zone: null,
          },
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        },
        arr: {
          export: [],
          filter : {
            staff: [],
            sellers: [],
          },
          select: {
            zones: [],
          }
        },
        filter: {
          date_start: '',
          date_end: '',
          title: '',
          staff: [],
          sellers: [],
        },
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.editReport = Helper.hasAccessElement(this.access, 'edit_report')
      this.access.elements.deleteReport = Helper.hasAccessElement(this.access, 'delete_report')
      /* Fin configuracion */
    },
    mounted() {
      this.filterLoad()
      this.filterReport()
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.title = ''
        this.crud.form.observations = ''
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.sellers_id = 0
        this.crud.form.sellers = null
        this.crud.form.sellers_zone_id = 0
        this.crud.form.sellers_zone = null
        this.arr.select.zones = []

        this.modal.form.title = "Nueva Minuta de Reunión"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.date = item.date
        this.crud.form.title = item.title || ''
        this.crud.form.observations = item.observations
        this.crud.form.staff_id = item.staff_id
        this.crud.form.sellers_id = item.sellers_id
        this.crud.form.sellers = item.seller
        this.crud.form.sellers_zone_id = item.sellers_zone_id
        this.crud.form.sellers_zone = item.zone ? { code: item.zone.id, label: item.zone.name } : null
        this.loadZones(item.sellers_id)

        this.modal.form.title = "Editar Minuta de Reunión"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id

        this.$bvModal.msgBoxConfirm('¿Desea borrar el item (' + this.crud.form.id + ')?', {
          title: 'Borrar Minuta',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminar(this.crud.form.id);

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.filterReport()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        this.$bvModal.msgBoxConfirm('¿Desea continuar con la operación?', {
          title: 'Guardar Minuta',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'Aceptar',
          cancelVariant: 'outline-dark',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'black',
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            if (this.crud.form.id) {
              var result = serviceAPI.editar(this.crud.form);
            } else {
              var result = serviceAPI.agregar(this.crud.form);
            }

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.filterReport()
              this.$awn.success("Datos guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      loadSellers (object) {
        if(object){
          this.crud.form.sellers = object
          this.crud.form.sellers_id = object.id
          this.crud.form.sellers_zone_id = 0
          this.crud.form.sellers_zone = null
          this.loadZones(object.id)
        } else {
          this.crud.form.sellers = null
          this.crud.form.sellers_id = 0
          this.crud.form.sellers_zone_id = 0
          this.crud.form.sellers_zone = null
          this.arr.select.zones = []
        }
      },
      loadZone (object) {
        if(object){
          this.crud.form.sellers_zone = object
          this.crud.form.sellers_zone_id = object.code
        } else {
          this.crud.form.sellers_zone = null
          this.crud.form.sellers_zone_id = 0
        }
      },
      loadZones (sellers_id) {
        if(!sellers_id) { this.arr.select.zones = []; return }
        var result = serviceAPI.obtenerZonasByVendedor({ sellers_id: sellers_id })
        result.then((response) => {
          this.arr.select.zones = []
          response.data.forEach(element => {
            this.arr.select.zones.push({ code: element.id, label: element.name })
          })
        })
      },

      filterLoad() {
        this.filterLoadStaff()
        this.filterLoadSellers()
        this.filter.date_start = moment().subtract(7, 'days').format('YYYY-MM-DD')
        this.filter.date_end = moment().format('YYYY-MM-DD')

        this.restoreFilterStorage()
      },
      filterLoadStaff() {
        var result = serviceAPI.obtenerStaff()
        result.then((response) => {
          var data = response.data

          this.arr.filter.staff = []
          data.forEach(element => {
            if(!element.seller) {
              this.arr.filter.staff.push({ code: element.id, label: element.name })
            }
          });
        })
      },
      filterLoadSellers() {
        var result = serviceAPI.obtenerVendedores()
        result.then((response) => {
          var data = response.data

          this.arr.filter.sellers = []
          data.forEach(element => {
            this.arr.filter.sellers.push({ code: element.id, label: element.name })
          });
        })
      },
      filterReport(){
        let loader = this.$loading.show()

        var result = serviceAPI.filtrarReport(this.filter)
        result.then((response) => {
          loader.hide()

          var data = response.data
          this.table.items = data
          this.prepareExport(data)
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      prepareExport(data) {
        this.arr.export = []
        data.forEach(element => {
          var staffID = 0
          var staffName = ''
          var sellersID = 0
          var sellersName = ''
          var zoneName = ''

          if(element.staff_id) {
            staffID = element.staff.id
            staffName = element.staff.name
          }

          if(element.sellers_id) {
            sellersID = element.seller.id
            sellersName = element.seller.name
          }

          if(element.zone) {
            zoneName = element.zone.name
          }

          this.arr.export.push({
            id: element.id,
            date: element.date,
            titulo: element.title || '',
            staffID: staffID,
            staffName: staffName,
            sellersID: sellersID,
            sellersName: sellersName,
            zona: zoneName,
            mensaje: element.observations
          })
        });
      },


      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_report_meetings', JSON.stringify(this.filter))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_report_meetings')) {
          this.filter = JSON.parse(Storage.getValue('filter_report_meetings'))
        }
      },

      irDetail(item){
        this.saveFilterStorage()
        const detailRoute = this.$route.name.includes('Admin')
          ? 'ReportsMeetingsAdminDetailReport'
          : 'ReportsMeetingsStaffDetailReport'
        this.$router.push({ name: detailRoute, params: {reportID: item.id} })
      },
    }
  }
</script>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;
  }
</style>
